/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_StateInputs */

const en_admin_external_booking_edit_state = /** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State`)
};

const de_admin_external_booking_edit_state = /** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundesland / Kanton`)
};

const es_admin_external_booking_edit_state = /** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provincia / Estado`)
};

const fr_admin_external_booking_edit_state = /** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Région / État`)
};

/** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */
const it_admin_external_booking_edit_state = en_admin_external_booking_edit_state;

/** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_state = en_admin_external_booking_edit_state;

/** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */
const pl_admin_external_booking_edit_state = en_admin_external_booking_edit_state;

/** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */
const hu_admin_external_booking_edit_state = en_admin_external_booking_edit_state;

/** @type {(inputs: Admin_External_Booking_Edit_StateInputs) => LocalizedString} */
const ro_admin_external_booking_edit_state = en_admin_external_booking_edit_state;

/**
* | output |
* | --- |
* | "State" |
*
* @param {Admin_External_Booking_Edit_StateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_state = /** @type {((inputs?: Admin_External_Booking_Edit_StateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_StateInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_state(inputs)
	if (locale === "de") return de_admin_external_booking_edit_state(inputs)
	if (locale === "es") return es_admin_external_booking_edit_state(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_state(inputs)
	if (locale === "it") return it_admin_external_booking_edit_state(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_state(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_state(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_state(inputs)
	return ro_admin_external_booking_edit_state(inputs)
});
export { admin_external_booking_edit_state as "admin.external_booking_edit.state" }